const CONST_DIFF_SCROLL_MIN = 210;

export const backToTopHandle = (event, backToTopBox) => {
    if(event.type === 'scroll') {
        let scrollTop = window.scrollY;

        if(scrollTop > CONST_DIFF_SCROLL_MIN)
            backToTopBox.scrollTop = null;

        backToTopBox.isOnTop = backToTopBox.scrollTop == null;

        showOrHideBackToTopBox(backToTopBox);
    }
    else if (event.type === 'click') {
        let current_scroll_top_position = window.scrollY;

        if(current_scroll_top_position < CONST_DIFF_SCROLL_MIN)
            window.scrollTo({top: backToTopBox.scrollTop, left: 0, behavior: 'instant'});
        else
        {
            window.scrollTo({top: 0, left: 0, behavior: 'instant'});
            backToTopBox.scrollTop = current_scroll_top_position;
        }
    }
    else if (event.type === 'mouseover') {
        backToTopBox.isOver = true;
    }
    else if (event.type === 'mouseout') {
        backToTopBox.isOver = false;
    }
    else if (event.type === 'resize') {
        showOrHideBackToTopBox(backToTopBox);
    }
}

export const showOrHideBackToTopBox = (backToTopBox) => {
    let document_width  = window.innerWidth;

    let scrollTop = window.scrollY;

    if(document_width <= 514 || (scrollTop < CONST_DIFF_SCROLL_MIN && backToTopBox.scrollTop == null)) {
        backToTopBox.show = false;
        return;
    }

    backToTopBox.show = true;
}